// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jm-1";
export var messageSideRight = "_jm-2";
export var orderLookupBubbleContainer = "_jm-0";
export var submitButton = "_jm-3";